import { config } from "@/config";
export const UnidadMedidaService = {
    async getAll() {
        const response = await fetch(`${config.API_URL}/api/UnidadesMedida`);
        if (!response.ok)
            throw new Error("Error al obtener unidades de medida");
        const result = await response.json();
        return result.data || [];
    },
    async add(unidad) {
        const response = await fetch(`${config.API_URL}/api/UnidadesMedida`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(unidad),
        });
        if (!response.ok)
            throw new Error("Error al crear unidad de medida");
    },
    async update(id, unidad) {
        const response = await fetch(`${config.API_URL}/api/UnidadesMedida/${id}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(unidad),
        });
        if (!response.ok)
            throw new Error("Error al actualizar unidad de medida");
    },
    async delete(id) {
        const response = await fetch(`${config.API_URL}/api/UnidadesMedida/${id}`, {
            method: "DELETE",
        });
        if (!response.ok)
            throw new Error("Error al eliminar unidad de medida");
    },
};
